import { ArrowTopRightBoldOutlineIcon } from './ArrowTopRightBoldOutlineIcon';

/**
 * author: Michael Irigoyen
 * id D6A6FF61-6566-4C1D-BBCC-30E00B0655DD
 * name arrow-top-right-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-right-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowUpRightBoldOutlineIcon = ArrowTopRightBoldOutlineIcon;
export default ArrowUpRightBoldOutlineIcon